import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Image from 'next/image';
import React from 'react';
import Slider from 'react-slick';

import { testimonialSettings } from '@/utils/constants/carousel/forexTestimonialSetting';

import Customer1 from '../../../../assets/images/icons/customer-forex-1.png';
import Customer2 from '../../../../assets/images/icons/customer-forex-2.png';
import Customer3 from '../../../../assets/images/icons/customer-forex-3.png';
// import { testimonials } from '@/utils/constants/digital-gold';

export const ForexTestimonial = () => {
  // const [isMobile, setIsMobile] = useState(false)

  return (
    <section className="bg bg--light">
      <div className="home__customer font-helvetica-neue">
        <div className="container">
          <h2 className="section__title-small text--bold text--black text-center">
            The Customer Is Always Right
          </h2>
          <p className="section__desc text--gray text-center">
            Trust is a key component to the way we treat our customers
          </p>
        </div>
        <div className="home__customer--slider">
          <div className="mfone-customer-testimonial mt-4">
            <div
              className=" blog-cards-container testimonial-container forex-mfo-cards testimonial_center"
              // style={{
              //   display: 'flex',
              //   justifyContent: 'center',
              //   flexWrap: 'nowrap',
              // }}
            >
              <Slider
                {...testimonialSettings}
                variableWidth={true}
                className="carousel-slider"
              >
                <div className="mfone-height-100 pr-2">
                  <div className="testimonial-card color-1 mfone-height-100">
                    <div className="text-box">
                      <div>
                        The
                        <span className="highlight">
                          {' '}
                          foreign remittance service is good, with minimal
                          paperwork.{' '}
                        </span>
                        Happy with the experience, too.
                      </div>
                    </div>
                    <div className="profile">
                      <Image
                        style={{ color: undefined }}
                        src={Customer1}
                        height={55}
                        alt="Customer 2"
                      />
                      <div>
                        <p className="title">Shakir Pasha</p>
                        <p className="description">
                          {' '}
                          Muthoot FinCorp remittance{' '}
                          <span className="content-break"> service user</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mfone-height-100 pr-2">
                  <div className="testimonial-card color-2 mfone-height-100">
                    <div className="text-box">
                      <div>
                        I am extremely happy, as
                        <span className="highlight">
                          {' '}
                          the service was quick, and the charges were nominal.{' '}
                        </span>
                        {/* I have recommented it to my friends */}
                      </div>
                    </div>
                    <div className="profile">
                      <Image
                        style={{ color: undefined }}
                        src={Customer2}
                        height={55}
                        alt="Customer 2"
                      />
                      <div>
                        <p className="title">R. Gayathri</p>
                        <p className="description">
                          {' '}
                          Muthoot FinCorp remittance{' '}
                          <span className="content-break"> service user</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mfone-height-100 pr-2">
                  <div className="testimonial-card color-3 mfone-height-100">
                    <div className="text-box">
                      <div>
                        The process is always{' '}
                        <span className="highlight ">tension-free, </span>
                        and{' '}
                        <span className="highlight">
                          {' '}
                          services are avaliable 24/7.
                        </span>
                      </div>
                    </div>
                    <div className="profile">
                      <Image
                        style={{ color: undefined }}
                        src={Customer3}
                        height={55}
                        alt="Customer 2"
                      />
                      <div>
                        <p className="title">Mohan K</p>
                        <p className="description">
                          {' '}
                          Muthoot FinCorp remittance{' '}
                          <span className="content-break"> service user</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
